import script from "./Career.vue?vue&type=script&setup=true&lang=ts"
export * from "./Career.vue?vue&type=script&setup=true&lang=ts"

import "./Career.vue?vue&type=style&index=0&id=23257c3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23257c3c"]])

export default __exports__